<ng-container *transloco="let t; read: 'password'">
  <div class="p-d-flex p-flex-column p-jc-center p-ai-center" style="height: 100vh;">
    <p-card header="{{ t('labels.assessment_runner_administration') }}">

      <div *ngIf="mode === PageModes.Password">
        <p>{{ t('text.set_new_password') }}</p>

        <p-messages [(value)]="messages"></p-messages>

        <form (ngSubmit)="onSubmit()" novalidate>
          <app-form-control [cid]="'onetime'" [control]="form.get('onetime')" [type]="'password'" [label]="t('labels.onetime_password')"></app-form-control>
          <app-form-control [cid]="'new'" [control]="form.get('new')" [type]="'password'" [label]="t('labels.new_password')"></app-form-control>
          <app-form-control [cid]="'confirm'" [control]="form.get('confirm')" [type]="'password'" [label]="t('labels.password_confirmation')"></app-form-control>
          <div class="p-grid">
            <div class="p-col">
              <button pButton type="button" label="{{ t('labels.back_to_login') }}" [routerLink]="['/login']" class="p-button-text"></button>
            </div>
            <div class="p-col p-text-right">
              <button pButton type="submit" label="{{ t('labels.send') }}" [disabled]="busy === true"></button>
            </div>
          </div>
        </form>
      </div>

      <div *ngIf="mode === PageModes.Success">
        <p class="p-text-center success-message">
          <fa-icon [icon]="faCheck"></fa-icon><br>
          {{ t('text.password_changed') }}
        </p>
        <p class="p-text-center"><a [routerLink]="['/login']">{{ t('labels.back_to_login') }}</a></p>
      </div>

    </p-card>
  </div>
</ng-container>
